import { MutableRefObject, useEffect, useRef } from 'react';

export function useClickOutside<Element = any>(
  handler: () => void,
  active = true
): MutableRefObject<Element> {
  const domNode = useRef(null);

  useEffect(() => {
    const maybeHandler = (event: any): void => {
      if (!active) return;

      const target = event.target as HTMLElement | null;
      const isTargetInConfirmation = Boolean(
        target?.closest?.(
          '#confirmation-modal-backdrop, [data-modal="confirmation"]'
        )
      );
      const isSelfInConfirmation = Boolean(
        domNode.current?.closest?.(
          '#confirmation-modal-backdrop, [data-modal="confirmation"]'
        )
      );

      const isInsideOverlay =
        (isTargetInConfirmation && !isSelfInConfirmation) ||
        Boolean(target?.closest?.('.chakra-toast, .chakra-portal'));

      if (!isInsideOverlay && !domNode.current?.contains(target)) {
        handler();
      }
    };

    document.addEventListener('mousedown', maybeHandler);

    return () => {
      document.removeEventListener('mousedown', maybeHandler);
    };
  }, [active, handler]);

  return domNode;
}
